import { render, staticRenderFns } from "./SToolbarSubject.vue?vue&type=template&id=5457cb05"
import script from "./SToolbarSubject.vue?vue&type=script&lang=js"
export * from "./SToolbarSubject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports